/**
 * システム日時(JST)取得
 * @returns
 */
export const dateJst = (): Date => {
  const date = new Date();
  const jstStr = date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
  return new Date(jstStr + `.${date.getMilliseconds()}`);
};
